import { render } from "./AddOrEditModal.vue?vue&type=template&id=607e20bc&scoped=true"
import script from "./AddOrEditModal.vue?vue&type=script&lang=js"
export * from "./AddOrEditModal.vue?vue&type=script&lang=js"

import "./AddOrEditModal.vue?vue&type=style&index=0&id=607e20bc&scoped=true&lang=less"

import exportComponent from "G:\\阳泉\\portal-display-new\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-607e20bc"]])

export default __exports__